"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenusianInsects = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Card_1 = require("../Card");
class VenusianInsects extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.VENUSIAN_INSECTS,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.MICROBE],
            cost: 5,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.venus(12)),
            metadata: {
                cardNumber: '260',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 Microbe to this card.', (eb) => {
                        eb.empty().startAction.microbes(1);
                    }).br;
                    b.vpText('1 VP for every 2nd Microbe on this card.');
                }),
                description: 'Requires Venus 12%.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.microbes(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        player.addResourceTo(this, { log: true });
        return undefined;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
}
exports.VenusianInsects = VenusianInsects;
//# sourceMappingURL=VenusianInsects.js.map